<template>
    <v-card>
    <!-- <h1>Registered pilots</h1> -->
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab v-for="item in items" :key="item.tab">{{ item.tab }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in items" :key="item.tab">
        <v-card flat>
          <!-- <v-card-text>{{ item.content }}</v-card-text> -->
          <div v-if="item.nr === 1">
            <EventAdminSms></EventAdminSms>
          </div>
          <div v-if="item.nr === 2">
            <EventAdminSteps></EventAdminSteps>
          </div>
          <div v-if="item.nr === 3">
            <v-card>
              <v-card-title>For Event Admin. Edit text templates. Coming...</v-card-title>
            </v-card>
          </div>
          <div v-if="item.nr === 4">
            <v-card>
              <v-card-title>
                <EventAdminStatistics></EventAdminStatistics>
              </v-card-title>
            </v-card>
          </div>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    </v-card>
</template>

<script>
// @ is an alias to /src
import EventAdminSteps from "@/components/airbox/EventAdminSteps.vue";
import EventAdminStatistics from "@/components/airbox/EventAdminStatistics.vue";
import EventAdminSms from "@/components/Admin/EventAdminSms.vue";

export default {
  name: "EventAdmin",
  data() {
    return {
      startInput: 0,
      tab: null,
      items: [
        { tab: "SMS", content: "Tab 1 Content", nr: 1 },
        { tab: "Roles", content: "Tab 2 Content", nr: 2 },
        { tab: "Templates", content: "Tab 3 Content", nr: 3 },
        { tab: "History", content: "Tab 4 Content", nr: 4 }
      ]
    };
  },
  components: {
    EventAdminSteps,
    EventAdminStatistics,
    EventAdminSms
  }
};
</script>